import { type IconProps } from "@octopus-energy/icons"
import { type Maybe } from "@oefr/utils/types"
import { getMarketNameIcon } from "./utils/getMarketNameIcon"

type MarketNameIconProps = {
    marketName: Maybe<string>
} & IconProps

export function MarketNameIcon({ marketName, ...iconProps }: MarketNameIconProps) {
    const Icon = getMarketNameIcon(marketName)

    if (!Icon) return null

    return (
        <Icon
            size={24}
            {...iconProps}
        />
    )
}
